import { Route } from '@angular/router';

export const routes: Route[] = [
  // Default redirect to login
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth',
  },

  // Auth (public)
  {
    path: 'auth',
    loadChildren: () => import('./domains/auth/routes'),
  },

  // Legacy login redirect
  {
    path: 'login',
    redirectTo: 'auth/sign-in',
  },

  // Registration (public) — consolidated builder-driven renderer
  {
    path: 'register',
    loadChildren: () => import('./domains/registration/register-routes'),
  },

  // Legacy /team-registration links → forward to the consolidated renderer.
  {
    path: 'team-registration/:org/:season',
    redirectTo: 'register/:org/:season',
  },

  // Errors
  {
    path: '',
    loadChildren: () => import('./domains/errors/routes'),
  },

  // Catch all → sign-in
  { path: '**', redirectTo: 'auth/sign-in' },
];
